import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function EmojiIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M7.5 11.5S8.25 13 10 13s2.5-1.5 2.5-1.5M8 8h.007"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M12 8h.007"
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 0.25
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 0.25
  }));
}

export { EmojiIcon };
//# sourceMappingURL=Emoji.mjs.map
